import {
  StaffLeadSection,
  StaffLeadSections,
  StaffLeadStatus,
  StaffLeadStatuses,
} from '@nebalkon-workspace/lead-api';

export const STAFF_LEAD_SECTIONS: StaffLeadSection[] = [
  StaffLeadSections.Callbacks,
  StaffLeadSections.Feedback,
  StaffLeadSections.Vacancies,
  StaffLeadSections.Birthdays,
  StaffLeadSections.ForeignRegistrations,
];

export type StaffLeadStatusFilter = StaffLeadStatus | 'all';

export interface StaffLeadSectionNavItem {
  id: StaffLeadSection;
  labelKey: string;
  kpiKey: string;
}

export interface StaffLeadStatusFilterItem {
  id: StaffLeadStatusFilter;
  labelKey: string;
}

export const STAFF_LEAD_SECTION_NAV: StaffLeadSectionNavItem[] = [
  {
    id: StaffLeadSections.Callbacks,
    labelKey: 'STAFF.LEADS.SECTION.CALLBACKS',
    kpiKey: 'STAFF.LEADS.KPI.CALLBACKS_NEW',
  },
  {
    id: StaffLeadSections.Feedback,
    labelKey: 'STAFF.LEADS.SECTION.FEEDBACK',
    kpiKey: 'STAFF.LEADS.KPI.FEEDBACK_NEW',
  },
  {
    id: StaffLeadSections.Vacancies,
    labelKey: 'STAFF.LEADS.SECTION.VACANCIES',
    kpiKey: 'STAFF.LEADS.KPI.VACANCIES_NEW',
  },
  {
    id: StaffLeadSections.Birthdays,
    labelKey: 'STAFF.LEADS.SECTION.BIRTHDAYS',
    kpiKey: 'STAFF.LEADS.KPI.BIRTHDAYS_NEW',
  },
  {
    id: StaffLeadSections.ForeignRegistrations,
    labelKey: 'STAFF.LEADS.SECTION.FOREIGN_REGISTRATIONS',
    kpiKey: 'STAFF.LEADS.KPI.FOREIGN_REGISTRATIONS_NEW',
  },
];

export const STAFF_LEAD_STATUS_FILTERS: StaffLeadStatusFilterItem[] = [
  { id: 'all', labelKey: 'STAFF.LEADS.STATUS.ALL' },
  { id: StaffLeadStatuses.New, labelKey: 'STAFF.LEADS.STATUS.NEW' },
  {
    id: StaffLeadStatuses.InProcess,
    labelKey: 'STAFF.LEADS.STATUS.IN_PROCESS',
  },
  {
    id: StaffLeadStatuses.Completed,
    labelKey: 'STAFF.LEADS.STATUS.COMPLETED',
  },
  {
    id: StaffLeadStatuses.Canceled,
    labelKey: 'STAFF.LEADS.STATUS.CANCELED',
  },
];

export function isStaffLeadSection(value: string | null): value is StaffLeadSection {
  return STAFF_LEAD_SECTIONS.includes(value as StaffLeadSection);
}

export function staffLeadKindLabelKey(kind: string): string {
  return `STAFF.LEADS.KIND.${kind.toUpperCase()}`;
}

export function staffLeadStatusLabelKey(status: string): string {
  return `STAFF.LEADS.STATUS.${status.toUpperCase()}`;
}

export function formatStaffLeadShortId(id: string): string {
  return id.replace(/-/g, '').slice(0, 8).toUpperCase();
}

export function staffLeadStatsValue(
  stats: {
    callbacks_new: number;
    feedback_new: number;
    vacancies_new: number;
    birthdays_new: number;
    foreign_registrations_new: number;
  } | null,
  section: StaffLeadSection,
): number {
  if (!stats) {
    return 0;
  }

  switch (section) {
    case StaffLeadSections.Callbacks:
      return stats.callbacks_new;
    case StaffLeadSections.Feedback:
      return stats.feedback_new;
    case StaffLeadSections.Vacancies:
      return stats.vacancies_new;
    case StaffLeadSections.Birthdays:
      return stats.birthdays_new;
    case StaffLeadSections.ForeignRegistrations:
      return stats.foreign_registrations_new;
    default:
      return 0;
  }
}
